module.exports = __webpack_public_path__ + "img/dark-kanban.625deb1f.png";